import { ROW_NORMAL_COL, ROW_BIG_COL, AREA_NORMAL_COL, AREA_BIG_COL } from './Item.const'

export const getRowSizeConfiguration = (size, index) => {
	switch (size) {
		case 6:
			return (
				[ROW_NORMAL_COL, ROW_BIG_COL, ROW_BIG_COL, ROW_BIG_COL, ROW_BIG_COL, ROW_NORMAL_COL][index] ??
				ROW_NORMAL_COL
			)

		default:
			return ROW_NORMAL_COL
	}
}

export const getAreaSizeConfiguration = (size, index) => {
	switch (size) {
		case 3:
			return [null, null, AREA_BIG_COL][index] ?? null

		case 5:
			return [null, null, null, null, AREA_BIG_COL][index] ?? null

		default:
			return null
	}
}

export const getAreaTemplateConfiguration = size => {
	switch (size) {
		case 3:
			return `"${AREA_NORMAL_COL} ${AREA_NORMAL_COL}" "${AREA_BIG_COL} ${AREA_BIG_COL}"`

		case 5:
			return `"${AREA_NORMAL_COL} ${AREA_NORMAL_COL}"
	                "${AREA_NORMAL_COL} ${AREA_NORMAL_COL}"
	                "${AREA_BIG_COL} ${AREA_BIG_COL}"`

		default:
			return null
	}
}
